import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import LoadingIcon from "./components/LoadingIcon";
import Header from "./global/Header";
import MenuBar from "./global/MenuBar";
import InfoSlider from "./components/InfoSlider";
import Exhibition from "./components/Exhibition";
import TextSlider from "./components/TextSlider";
import { prodApi } from "./data/api";
import { guesthouseNumber, guesthouseData } from "./data/database";
import Footer from "./global/Footer";
import "../src/styles/index.css";
import { fetchData } from "./functions";

const Layout = () => {
  const [menuData, setMenuData] = useState([]);
  const [exhibitsData, setExhibitsData] = useState([]);
  const [guestroomsData, setGuestroomsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        setLoading(true);
        const [menuData, exhibitsData, guestroomsData] = await Promise.all([
          fetchData(prodApi.products),
          fetchData(prodApi.exhibits),
          fetchData(prodApi.guestrooms),
        ]);
        setMenuData(menuData);
        setExhibitsData(exhibitsData);
        setGuestroomsData(guestroomsData);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to load data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "1000px",
        margin: "auto",
      }}
    >
      <Outlet />
      <Header />
      <MenuBar menuData={menuData} />
      {loading ? (
        <Box sx={{ height: "300px", display: "grid", placeItems: "center" }}>
          <LoadingIcon />
        </Box>
      ) : error ? (
        <Box sx={{ textAlign: "center", p: 4, color: "error.main" }}>
          {error}
        </Box>
      ) : (
        <>
          <InfoSlider data={guestroomsData} whatsappNumber={guesthouseNumber} />
          <Exhibition data={exhibitsData} />
          <TextSlider data={guesthouseData} />
        </>
      )}

      <Box sx={{ height: "2rem" }} />
      <Footer />
    </Box>
  );
};

const App = () => {
  return (
    <Box
      className="App"
      sx={{
        width: "100dvw",
        maxWidth: "1000px",
        cursor: "pointer",
        overflowX: "hidden",
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}></Route>
        </Routes>
      </BrowserRouter>
    </Box>
  );
};

export default App;
